import { ENV } from "../utils";

export class BalanceHidricoForm {
  baseApi = ENV.BASE_API;

  async getBalanceHidrico(accessToken, id) {
    try {
      const url = `${this.baseApi}/balance-hidrico/${id}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getBalanceHidricoBySiteAndPeriodAndYear(accessToken, site, period, year) {
    try {
      const url = `${this.baseApi}/balance-hidrico-site/${site}/${period}/${year}`;
      const params = { headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createBalanceHidrico(accessToken, data) {
    try {
      const url = `${this.baseApi}/add-balance-hidrico`;
      const params = {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateBalanceHidrico(accessToken, id, data) {
    try {
      const url = `${this.baseApi}/update-balance-hidrico/${id}`;
      const params = {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteBalanceHidrico(accessToken, id) {
    try {
      const url = `${this.baseApi}/delete-balance-hidrico/${id}`;
      const params = { method: "DELETE", headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  // data = FormData con un campo "files" (la evidencia)
  async uploadFile(accessToken, data) {
    try {
      const url = `${this.baseApi}/upload-file-balancehidrico/`;
      const params = { method: "POST", body: data, headers: { Authorization: `Bearer ${accessToken}` } };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteFile(accessToken, fileName) {
    try {
      const url = `${this.baseApi}/delete-file-balancehidrico`;
      const params = {
        method: "DELETE",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify({ fileName }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  getFileUrl(fileName) {
    return `${this.baseApi}/get-file-balancehidrico/${fileName}`;
  }
}

export default BalanceHidricoForm;
